import { apiClient } from '../services/api';

export const PENDING_ORDER_KEY = 'pendingOrderVerification';

export function clearPendingOrder() {
  localStorage.removeItem(PENDING_ORDER_KEY);
}

/** Yerel pending havale kaydı hâlâ geçerli mi? (API çağrısı yok) */
export function getLocalPendingHavaleState(pending) {
  if (!pending?.orderId) {
    return { canContinue: false, shouldClear: true };
  }

  const isHavale =
    pending.paymentMethod === 'HAVALE' || pending.paymentMethod === 'WIRE_TRANSFER';
  if (!isHavale) {
    return { canContinue: false, shouldClear: false };
  }

  const createdAt = pending.orderCreatedAt || null;
  const priceLockDeadline =
    pending.priceLockDeadline ||
    (createdAt && pending.priceLockSeconds
      ? createdAt + pending.priceLockSeconds * 1000
      : pending.orderDeadline || null);
  const receiptDeadline =
    pending.receiptDeadline ||
    pending.priceLockDeadline ||
    (createdAt && pending.priceLockSeconds
      ? createdAt + pending.priceLockSeconds * 1000
      : pending.orderDeadline || null);

  const priceLockExpired = priceLockDeadline ? Date.now() > priceLockDeadline : false;
  const receiptWindowExpired = receiptDeadline ? Date.now() > receiptDeadline : false;

  return {
    canContinue: true,
    shouldClear: false,
    priceLockExpired,
    receiptWindowExpired,
  };
}

/** Opsiyonel sunucu doğrulama — yalnızca açıkça istendiğinde kullan */
export async function fetchHavalePaymentStatus(orderId, paymentToken) {
  const params = paymentToken ? { paymentToken } : {};
  return apiClient.get(`/orders/${orderId}/havale-status`, { params });
}

export async function resolvePendingHavaleOrder(pending) {
  const local = getLocalPendingHavaleState(pending);
  if (!local.canContinue || local.shouldClear) {
    return { ...local, status: null };
  }
  return { ...local, status: null };
}
